import axios from "axios";
import { DateTime } from "luxon";

export const baseURL = process.env.REACT_APP_API_URL;
const ApiClient = () => {
  const defaultOptions = {
    baseURL,
  };
  const instance = axios.create(defaultOptions);

  instance.interceptors.request.use(async (request) => {
    const token = localStorage.getItem("auth");
    const stateCache = localStorage.getItem("auth_state");
    const state = JSON.parse(stateCache ?? "{}");

    const now = DateTime.now();
    if (state && DateTime.fromISO(state.expiresIn) <= DateTime.now()) {
      localStorage.removeItem("auth");
      localStorage.removeItem("auth_state");
      window.location.reload();
    }
    if (
      state.expiresIn &&
      ((state && DateTime.fromISO(state.expiresIn) <= now) ||
        (!state.admin && state.position > 2 && now.hour > 20) ||
        (!state.admin && state.position > 2 && now.hour < 7) ||
        (!state.admin && state.position > 2 && now.weekday < 1) ||
        (!state.admin && state.position > 2 && now.weekday > 5))
    ) {
      localStorage.removeItem("auth");
      localStorage.removeItem("auth_state");
      window.location.reload();
      window.location.replace("/login");
    }
    request.headers.Authorization = `Bearer ${token}`;
    return request;
  });

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem("auth");
        localStorage.removeItem("auth_state");
        window.location.reload();
        window.location.replace("/login");
      }
      console.log(`error`, error);
      throw error;
    },
  );

  return instance;
};

export default ApiClient();
